import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaHome, FaFileAlt, FaUsers, FaBuilding, FaImages, FaEnvelope, FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa';

const AdminDashboard = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (!token) {
      navigate('/AfAdmin');
      return;
    }

    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/AfAdmin');
  };

  const menuItems = [
    { icon: <FaHome />, label: 'Dashboard', path: '/AfAdmin/dashboard' },
    { icon: <FaFileAlt />, label: 'Pages', path: '/AfAdmin/pages' },
    { icon: <FaUsers />, label: 'Team Members', path: '/AfAdmin/team' },
    { icon: <FaBuilding />, label: 'Company Info', path: '/AfAdmin/company' },
    { icon: <FaImages />, label: 'Gallery', path: '/AfAdmin/gallery' },
    { icon: <FaEnvelope />, label: 'Messages', path: '/AfAdmin/messages' },
  ];

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className={`${isSidebarOpen ? 'w-64' : 'w-20'} bg-maroon-900 text-white transition-all duration-300 overflow-hidden`}>
        <div className="p-4">
          <div className="flex items-center justify-between mb-8">
            {isSidebarOpen && (
              <h1 className="text-xl font-bold">AFTRUSTCA Admin</h1>
            )}
            <button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="text-white hover:bg-maroon-800 p-2 rounded"
            >
              {isSidebarOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

          <nav className="space-y-2">
            {menuItems.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                className="flex items-center space-x-3 px-4 py-3 rounded-lg hover:bg-maroon-800 transition-colors duration-200"
              >
                <span className="text-xl">{item.icon}</span>
                {isSidebarOpen && <span>{item.label}</span>}
              </Link>
            ))}
          </nav>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-maroon-800">
          <button
            onClick={handleLogout}
            className="flex items-center space-x-3 px-4 py-3 rounded-lg hover:bg-maroon-800 transition-colors duration-200 w-full"
          >
            <FaSignOutAlt className="text-xl" />
            {isSidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Bar */}
        <header className="bg-white shadow-md z-10">
          <div className="px-6 py-4 flex items-center justify-between">
            <h2 className="text-2xl font-bold text-gray-800">Admin Dashboard</h2>
            <div className="flex items-center space-x-4">
              <span className="text-gray-600">Welcome, {user?.username}</span>
              <div className="bg-maroon-700 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold">
                {user?.username?.charAt(0).toUpperCase()}
              </div>
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;
